import { ReactElement, useCallback, useEffect, useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import { ImageListItem } from "@mui/material";
import { isEmpty } from "lodash";
import { getActiveImagesList } from "../../services/ImagesServices";
import { image } from "./SharedInterfaces";

const ImageComponent = ({ articleId }: { articleId: number }): ReactElement => {
  const [imgeData, setImageData] = useState<image[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  /* const getImages = useCallback(() => {
    getActiveImagesList(setImageData, articleId);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [articleId]); */

  /**
   * ✅ CAMBIO:
   * Validamos que `articleId > 0` antes de hacer la petición,
   * para evitar errores cuando el ID está vacío o inválido.
   * También se agrega un `setIsLoading(false)` para que no se quede cargando si el ID no es válido.
   */

  const getImages = useCallback(() => {
    if (articleId > 0) {
      getActiveImagesList(setImageData, articleId);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    } else {
      console.warn("articleId inválido:", articleId);
      setIsLoading(false);
    }
  }, [articleId]);

  /*  const renderImages = () => {
    if (!isEmpty(imgeData)) {
      return imgeData.map((image) => {
        return (
          <ImageListItem>
            <img
              src={`data:image/png;base64,${image.content}`}
              alt={image.name}
            />
          </ImageListItem>
        );
      });
    } else {
      return <p>No images</p>;
    }
  }; */

  /**
   * ✅ CAMBIO:
   * Agregamos `key={image.id}` al componente `ImageListItem`
   * para evitar el warning de React: "Each child in a list should have a unique key prop".
   */
  const renderImages = () => {
    if (!isEmpty(imgeData)) {
      return imgeData.map((image) => (
        <ImageListItem key={image.id}>
          <img
            src={`data:image/png;base64,${atob(image.content)}`}
            alt={image.name}
          />
        </ImageListItem>
      ));
    } else {
      return <p>No images</p>;
    }
  };

  useEffect(() => {
    if (isLoading) getImages();
  }, [isLoading, getImages]);

  return (
    <>
      {isLoading ? (
        <>
          <p>loading</p>
          <LoadingSpinner />
        </>
      ) : (
        renderImages()
      )}
    </>
  );
};

export default ImageComponent;
